import { authSelector } from '../redux-toolkits/auth/auth.selector'
import { PermissionCode } from '../redux-toolkits/auth/auth.type'
import { useAppSelector } from './useAppSelector'

export const usePermissions = () => {
  const { user } = useAppSelector(authSelector)

  const hasPermissions = (permissions: PermissionCode[]) => {
    return permissions.every((permission) =>
      [
        ...(user?.role?.permissions?.map((p) => p.code) ?? []),
        ...(user?.customPermissions?.map((p) => p.code) ?? []),
      ].includes(permission),
    )
  }

  return { hasPermissions }
}
